// extracted by mini-css-extract-plugin
export default {"cls1":"Kqsm6oB_gFf9Rbw0EJPg","cls2":"X0bp65E2pmeu_qPrJEQ3 Kqsm6oB_gFf9Rbw0EJPg"};